module.exports = __webpack_public_path__ + "img/footdh_icon.584e2c5.png";